module.exports = __webpack_public_path__ + "img/back_m4.b04f836e.png";